import { Box, CircularProgress, Typography } from '@mui/material';
import InboxOutlinedIcon from '@mui/icons-material/InboxOutlined';

interface EmptyStateProps {
  message: string;
  loading?: boolean;
}

/** Shared empty/loading placeholder for compact widget cards and lists. */
export const EmptyState = ({ message, loading }: EmptyStateProps) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      py: 4,
      color: 'text.secondary',
    }}
  >
    {loading ? (
      <CircularProgress size={22} sx={{ mb: 1.5 }} />
    ) : (
      <InboxOutlinedIcon sx={{ fontSize: 28, mb: 1, opacity: 0.5 }} />
    )}
    <Typography variant="body2">{loading ? 'Loading…' : message}</Typography>
  </Box>
);
